import ApiService from "@/modules/api/api.service";
import ObjectBuilderInterface from "@/modules/api/object-builder.interface";

import FutureTurnaround from "./future-turnaround.model";

export default class FutureTurnaroundRepository {
  private readonly fResourceName = "future_turnaround_stats";

  constructor(
    private api: ApiService,
    private objectBuilder: ObjectBuilderInterface<FutureTurnaround>
  ) {}

  public async fetchFutureTurnaroundList(
    weeksCount: number,
    inProductionAdj: number,
    qualityInspectionAdj: number,
    inReworkAdj: number
  ): Promise<FutureTurnaround[]> {
    const response = await this.api.get(this.fResourceName, {
      weeksCount,
      inProductionAdj,
      qualityInspectionAdj,
      inReworkAdj,
    });

    return (response.data as any[]).map((item) =>
      this.objectBuilder.buildFromJSON(item)
    );
  }
}
